import { Link } from 'react-router-dom';
import { useI18n } from '@/i18n';

// Styles
import styles from './Button.module.css';

type ButtonProps = {
  title: string;
  bgColor: 'white' | 'red';
  url: string;
}

function Button({
  title,
  bgColor = 'white',
  url,
}: ButtonProps) {
  const { localizedPath } = useI18n();

  return (
    <Link
      to={localizedPath(url)}
      className={`
        ${styles.button}
        ${styles[bgColor]}
      `}
    >
      {title}
    </Link>
  );
}

export default Button;